import { render, staticRenderFns } from "./TheaterList.vue?vue&type=template&id=676084c2&scoped=true&"
import script from "./TheaterList.vue?vue&type=script&lang=js&"
export * from "./TheaterList.vue?vue&type=script&lang=js&"
import style0 from "./TheaterList.vue?vue&type=style&index=0&id=676084c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676084c2",
  null
  
)

export default component.exports